import { DeserializedServer as Server, InterpretedServer } from '@amzn/awscat-portfolio-assessment-types';

// TODO: This entire file should be replaced. Column definitions should be generated from this file in Data models package
// https://code.amazon.com/packages/AWSCAT-PortfolioDataModels/blobs/mainline/--/src/models/schema/fixed-schema/server-headers.ts
// https://sim.amazon.com/issues/PAT-32734
export const ServerColumnDefinition: {[key in keyof Partial<InterpretedServer<Server>>]: any} = {
    portfolioId: {
        cell: (item: Server) => item.portfolioId,
        header: 'portfolioId',
        hidden: true,
        id: 'Portfolio ID',
    },
    serverId: {
        cell: (item: Server) => item.serverId,
        header: 'Server ID',
        hidden: true,
        id: 'serverId',
    },
    'server.VMwareInfo.datacenterId': {
        cell: (item: Server) => item['server.VMwareInfo.datacenterId'],
        header: 'Datacenter ID',
        hidden: true,
        id: 'server.VMwareInfo.datacenterId',
    },
    'server.VMwareInfo.hostId': {
        cell: (item: Server) => item['server.VMwareInfo.hostId'],
        header: 'Server-Host ID',
        hidden: true,
        id: 'server.VMwareInfo.hostId',
    },
    'server.VMwareInfo.manufacturer': {
        cell: (item: Server) => item['server.VMwareInfo.manufacturer'],
        header: 'Manufacturer',
        hidden: true,
        id: 'server.VMwareInfo.manufacturer',
    },
    'server.VMwareInfo.moRefId': {
        cell: (item: Server) => item['server.VMwareInfo.moRefId'],
        header: 'Server-VMware Ref ID',
        hidden: true,
        id: 'server.VMwareInfo.moRefId',
    },
    'server.VMwareInfo.toolsStatus': {
        cell: (item: Server) => item['server.VMwareInfo.toolsStatus'],
        header: 'Tools Status',
        hidden: true,
        id: 'server.VMwareInfo.toolsStatus',
    },
    'server.VMwareInfo.vCenterId': {
        cell: (item: Server) => item['server.VMwareInfo.vCenterId'],
        header: 'V-Center Id',
        hidden: true,
        id: 'server.VMwareInfo.vCenterId',
    },
    'server.VMwareInfo.vCenterName': {
        cell: (item: Server) => item['server.VMwareInfo.vCenterName'],
        header: 'V-Center Name',
        hidden: true,
        id: 'server.VMwareInfo.vCenterName',
    },
    'server.VMwareInfo.vmFolderPath': {
        cell: (item: Server) => item['server.VMwareInfo.vmFolderPath'],
        header: 'V-Folder Name',
        hidden: true,
        id: 'server.VMwareInfo.vmFolderPath',
    },
    'server.VMwareInfo.vmName': {
        cell: (item: Server) => item['server.VMwareInfo.vmName'],
        header: 'VM Name',
        hidden: true,
        id: 'server.VMwareInfo.vmName',
    },
    'server.configurationId': {
        cell: (item: Server) => item['server.configurationId'],
        header: 'Server-Configuration ID',
        hidden: true,
        id: 'server.configurationId',
    },
    'server.connectorId': {
        cell: (item: Server) => item['server.connectorId'],
        header: 'Server-Connection ID',
        hidden: true,
        id: 'server.connectorId',
    },
    'server.cpuType': {
        cell: (item: Server) => item['server.cpuType'],
        header: 'CPU-Type',
        hidden: true,
        id: 'server.cpuType',
    },
    'server.hostName': {
        cell: (item: Server) => item['server.hostName'],
        header: 'Server-Hostname',
        hidden: true,
        id: 'server.hostName',
    },
    'server.hypervisor': {
        cell: (item: Server) => item['server.hypervisor'],
        header: 'Hypervisor',
        hidden: true,
        id: 'server.hypervisor',
    },
    'server.networkInterfaceInfo': {
        cell: (item: Server) => item['server.networkInterfaceInfo'],
        header: 'Network Interface Information',
        hidden: true,
        id: 'server.networkInterfaceInfo',
    },
    'server.networkInterfaceInfo.hasMoreValues': {
        cell: (item: Server) => item['server.networkInterfaceInfo.hasMoreValues'],
        header: 'Network Interface Information-More',
        hidden: true,
        id: 'server.networkInterfaceInfo.hasMoreValues',
    },
    'server.osName': {
        cell: (item: Server) => item['server.osName'],
        header: 'OS Name',
        hidden: true,
        id: 'server.osName',
    },
    'server.osVersion': {
        cell: (item: Server) => item['server.osVersion'],
        header: 'OS Version',
        hidden: true,
        id: 'server.osVersion',
    },
    'server.performance.avgCpuUsagePct': {
        cell: (item: Server) => item['server.performance.avgCpuUsagePct'],
        header: 'CPU-Average Utilization (%)',
        hidden: true,
        id: 'server.performance.avgCpuUsagePct',
    },
    'server.performance.avgDiskReadIOPS': {
        cell: (item: Server) => item['server.performance.avgDiskReadIOPS'],
        header: 'Storage-Average Read IOPS',
        hidden: true,
        id: 'server.performance.avgDiskReadIOPS',
    },
    'server.performance.avgDiskReadsPerSecondInKB': {
        cell: (item: Server) => item['server.performance.avgDiskReadsPerSecondInKB'],
        header: 'Storage-Average Read IOPS Size (KB)',
        hidden: true,
        id: 'server.performance.avgDiskReadsPerSecondInKB',
    },
    'server.performance.avgDiskWriteIOPS': {
        cell: (item: Server) => item['server.performance.avgDiskWriteIOPS'],
        header: 'Storage-Average Write IOPS',
        hidden: true,
        id: 'server.performance.avgDiskWriteIOPS',
    },
    'server.performance.avgDiskWritesPerSecondInKB': {
        cell: (item: Server) => item['server.performance.avgDiskWritesPerSecondInKB'],
        header: 'Storage-Average Write IOPS Size (KB)',
        hidden: true,
        id: 'server.performance.avgDiskWritesPerSecondInKB',
    },
    'server.performance.avgFreeRAMInKB': {
        cell: (item: Server) => item['server.performance.avgFreeRAMInKB'],
        header: 'RAM-Free RAM Size (KB)',
        hidden: true,
        id: 'server.performance.avgFreeRAMInKB',
    },
    'server.performance.avgNetworkReadsPerSecondInKB': {
        cell: (item: Server) => item['server.performance.avgNetworkReadsPerSecondInKB'],
        header: 'Network-Average Read Size (KB)',
        hidden: true,
        id: 'server.performance.avgNetworkReadsPerSecondInKB',
    },
    'server.performance.avgNetworkWritesPerSecondInKB': {
        cell: (item: Server) => item['server.performance.avgNetworkWritesPerSecondInKB'],
        header: 'Network-Average Write Size (KB)',
        hidden: true,
        id: 'server.performance.avgNetworkWritesPerSecondInKB',
    },
    'server.performance.maxCpuUsagePct': {
        cell: (item: Server) => item['server.performance.maxCpuUsagePct'],
        header: 'CPU-Peak Utilization (%)',
        hidden: true,
        id: 'server.performance.maxCpuUsagePct',
    },
    'server.performance.maxDiskReadIOPS': {
        cell: (item: Server) => item['server.performance.maxDiskReadIOPS'],
        header: 'Storage-Max Read IOPS',
        hidden: true,
        id: 'server.performance.maxDiskReadIOPS',
    },
    'server.performance.maxDiskReadsPerSecondInKB': {
        cell: (item: Server) => item['server.performance.maxDiskReadsPerSecondInKB'],
        header: 'Storage-Max Read IOPS Size (KB)',
        hidden: true,
        id: 'server.performance.maxDiskReadsPerSecondInKB',
    },
    'server.performance.maxDiskWriteIOPS': {
        cell: (item: Server) => item['server.performance.maxDiskWriteIOPS'],
        header: 'Storage-Max Write IOPS',
        hidden: true,
        id: 'server.performance.maxDiskWriteIOPS',
    },
    'server.performance.maxDiskWritesPerSecondInKB': {
        cell: (item: Server) => item['server.performance.maxDiskWritesPerSecondInKB'],
        header: 'Storage-Max Write IOPS Size (KB)',
        hidden: true,
        id: 'server.performance.maxDiskWritesPerSecondInKB',
    },
    'server.performance.maxNetworkReadsPerSecondInKB': {
        cell: (item: Server) => item['server.performance.maxNetworkReadsPerSecondInKB'],
        header: 'Network-Max Read Size (KB)',
        hidden: true,
        id: 'server.performance.maxNetworkReadsPerSecondInKB',
    },
    'server.performance.maxNetworkWritesPerSecondInKB': {
        cell: (item: Server) => item['server.performance.maxNetworkWritesPerSecondInKB'],
        header: 'Network-Max Write Size (KB)',
        hidden: true,
        id: 'server.performance.maxNetworkWritesPerSecondInKB',
    },
    'server.performance.memoryReservation': {
        cell: (item: Server) => item['server.performance.memoryReservation'],
        header: 'Memory Reservation',
        hidden: true,
        id: 'server.performance.memoryReservation',
    },
    'server.performance.numCores': {
        cell: (item: Server) => item['server.performance.numCores'],
        header: 'CPU-Cores per Processor',
        hidden: true,
        id: 'server.performance.numCores',
    },
    'server.performance.numCpus': {
        cell: (item: Server) => item['server.performance.numCpus'],
        header: 'CPU-Number of Processors',
        hidden: true,
        id: 'server.performance.numCpus',
    },
    'server.performance.numDisks': {
        cell: (item: Server) => item['server.performance.numDisks'],
        header: 'Storage-Disk Count',
        hidden: true,
        id: 'server.performance.numDisks',
    },
    'server.performance.numNetworkCards': {
        cell: (item: Server) => item['server.performance.numNetworkCards'],
        header: 'Network-Number of Cards',
        hidden: true,
        id: 'server.performance.numNetworkCards',
    },
    'server.performance.powerState': {
        cell: (item: Server) => item['server.performance.powerState'],
        header: 'Server-Power State',
        hidden: true,
        id: 'server.performance.powerState',
    },
    'server.performance.totalDiskSizeInKB': {
        cell: (item: Server) => item['server.performance.totalDiskSizeInKB'],
        header: 'Storage-Total Disk Size (KB)',
        hidden: true,
        id: 'server.performance.totalDiskSizeInKB',
    },
    'server.performance.totalRAMInKB': {
        cell: (item: Server) => item['server.performance.totalRAMInKB'],
        header: 'RAM-Total Size (KB)',
        hidden: true,
        id: 'server.performance.totalRAMInKB',
    },
    'server.smBiosId': {
        cell: (item: Server) => item['server.smBiosId'],
        header: 'Server-BioS ID',
        hidden: true,
        id: 'server.smBiosId',
    },
    'server.tenancy': {
        cell: (item: Server) => item['server.tenancy'],
        header: 'Tenancy',
        hidden: true,
        id: 'server.tenancy',
    },
    'server.type': {
        cell: (item: Server) => item['server.type'],
        header: 'Server-Type',
        hidden: true,
        id: 'server.type',
    },
    'server.usagePct': {
        cell: (item: Server) => item['server.usagePct'],
        header: 'Server-Usage (%)',
        hidden: true,
        id: 'server.usagePct',
    },
    'server.targetHostType': {
        cell: (item: Server) => item['server.targetHostType'],
        header: 'Server-Target Host Type',
        hidden: true,
        id: 'server.targetHostType',
    },
    serverEnvironment: {
        cell: (item: Server) => item.serverEnvironment,
        header: 'Environment Name',
        hidden: true,
        id: 'serverEnvironment',
    },
    environmentType: {
        cell: (item: Server) => item.environmentType,
        header: 'Environment Type',
        hidden: true,
        id: 'environmentType'
    },
    inScope: {
        cell: (item: Server) => item.inScope,
        header: 'In Scope of Portfolio',
        hidden: true,
        id: 'inScope',
    },
    ec2RecommendationOverrideAvgUtilization: {
        cell: (item: Server) => item.ec2RecommendationOverrideAvgUtilization,
        header: 'ec2RecommendationOverrideAvgUtilization',
        hidden: true,
        id: 'ec2RecommendationOverrideAvgUtilization',
    },
    ec2RecommendationOverridePeakUtilization: {
        cell: (item: Server) => item.ec2RecommendationOverridePeakUtilization,
        header: 'ec2RecommendationOverridePeakUtilization',
        hidden: true,
        id: 'ec2RecommendationOverridePeakUtilization',
    },
    ec2RecommendationOverrideOnPremCapacity: {
        cell: (item: Server) => item.ec2RecommendationOverrideOnPremCapacity,
        header: 'ec2RecommendationOverrideOnPremCapacity',
        hidden: true,
        id: 'ec2RecommendationOverrideOnPremCapacity',
    },
    avgRamUsagePct: {
        cell: (item: Server) => item.avgRamUsagePct,
        header: 'RAM-Average Utilization (%)',
        hidden: true,
        id: 'avgRamUsagePct',
    },
    clusterName: {
        cell: (item: Server) => item.clusterName,
        header: 'Cluster Name',
        hidden: true,
        id: 'clusterName',
    },
    cpuSpeed: {
        cell: (item: Server) => item.cpuSpeed,
        header: 'CPU-Speed (GHz)',
        hidden: true,
        id: 'cpuSpeed',
    },
    database: {
        cell: (item: Server) => item.database,
        header: 'Database',
        hidden: true,
        id: 'database',
    },
    isPhysical: {
        cell: (item: Server) => item.isPhysical,
        header: 'Physical/Virtual',
        hidden: true,
        id: 'isPhysical',
    },
    maxRamUsagePct: {
        cell: (item: Server) => item.maxRamUsagePct,
        header: 'RAM-Peak Utilization (%)',
        hidden: true,
        id: 'maxRamUsagePct',
    },
    reportingRequirements: {
        cell: (item: Server) => item.reportingRequirements,
        header: 'Reporting Requirements',
        hidden: true,
        id: 'reportingRequirements',
    },
    serverSupportId: {
        cell: (item: Server) => item.serverSupportId,
        header: 'Server Support Id',
        hidden: true,
        id: 'serverSupportId',
    },
    serverSupportEmail: {
        cell: (item: Server) => item.serverSupportEmail,
        header: 'Server-Owner\'s Email ID',
        hidden: true,
        id: 'serverSupportEmail',
    },
    serverSupportName: {
        cell: (item: Server) => item.serverSupportName,
        header: 'Server-Owner\'s Name',
        hidden: true,
        id: 'serverSupportName',
    },
    serverSupportPhone: {
        cell: (item: Server) => item.serverSupportPhone,
        header: 'Server-Owner\'s Phone',
        hidden: true,
        id: 'serverSupportPhone',
    },
    totalDiskUsagePct: {
        cell: (item: Server) => item.totalDiskUsagePct,
        header: 'Storage-Utilization (%)',
        hidden: true,
        id: 'totalDiskUsagePct',
    },
    ipAddresses: {
        cell: (item: Server) => item.ipAddresses,
        header: 'IP Address',
        hidden: true,
        id: 'ipAddresses',
    },
    networkCardSpeeds: {
        cell: (item: Server) => item.networkCardSpeeds,
        header: 'Network Card Speed',
        hidden: true,
        id: 'networkCardSpeeds',
    },
    databaseID: {
        cell: (item: Server) => item.databaseID,
        header: 'Database ID',
        hidden: true,
        id: 'databaseID',
    },
    databaseName: {
        cell: (item: Server) => item.databaseName,
        header: 'Database Name',
        hidden: true,
        id: 'databaseName',
    },
    databaseEngine: {
        cell: (item: Server) => item.databaseEngine,
        header: 'Database Engine',
        hidden: true,
        id: 'databaseEngine',
    },
    databaseVersion: {
        cell: (item: Server) => item.databaseVersion,
        header: 'Database Version',
        hidden: true,
        id: 'databaseVersion',
    },
    databaseSizeGB: {
        cell: (item: Server) => item.databaseSizeGB,
        header: 'Database Size (GB)',
        hidden: true,
        id: 'databaseSizeGB',
    },
    DBALead: {
        cell: (item: Server) => item.DBALead,
        header: 'DBA Lead',
        hidden: true,
        id: 'DBALead',
    },
    DBALeadEmail: {
        cell: (item: Server) => item.DBALeadEmail,
        header: 'DBA Lead Email',
        hidden: true,
        id: 'DBALeadEmail',
    },
    DBALeadPhone: {
        cell: (item: Server) => item.DBALeadPhone,
        header: 'DBA Lead Phone',
        hidden: true,
        id: 'DBALeadPhone',
    },
    migrationPlan: {
        cell: (item: Server) => item.migrationPlan,
        header: 'Server-Migration Pattern (Imported)',
        hidden: true,
        id: 'migrationPlan',
    },
    additionalAttribute1: {
        cell: (item: Server) => item.additionalAttribute1,
        header: 'Additional Attribute 1',
        hidden: true,
        id: 'additionalAttribute1',
    },
    additionalAttribute2: {
        cell: (item: Server) => item.additionalAttribute2,
        header: 'Additional Attribute 2',
        hidden: true,
        id: 'additionalAttribute2',
    },
    additionalAttribute3: {
        cell: (item: Server) => item.additionalAttribute3,
        header: 'Additional Attribute 3',
        hidden: true,
        id: 'additionalAttribute3',
    },
    additionalAttribute4: {
        cell: (item: Server) => item.additionalAttribute4,
        header: 'Additional Attribute 4',
        hidden: true,
        id: 'additionalAttribute4',
    },
    additionalAttribute5: {
        cell: (item: Server) => item.additionalAttribute5,
        header: 'Additional Attribute 5',
        hidden: true,
        id: 'additionalAttribute5',
    },
    workload: {
        cell: (item: Server) => item.workload,
        header: 'Workload',
        hidden: true,
        id: 'workload',
    },
    dataSource: {
        cell: (item: Server) => item.dataSource,
        header: 'Data Source',
        hidden: true,
        id: 'dataSource',
    },
    questionnaireId: {
        cell: (item: Server) => item.questionnaireId,
        header: 'Questionnaire Id',
        hidden: true,
        id: 'questionnaireId',
    },
    isSharedInfrastructure: {
        cell: (item: Server) => item.isSharedInfrastructure,
        header: 'Is Shared Infrastructure',
        hidden: true,
        id: 'isSharedInfrastructure',
    },
    tags: {
        cell: (item: Server) => item.tags,
        header: 'Tags',
        hidden: true,
        id: 'tags',
    },
    migrationPlanOverride: {
        cell: (item: Server) => item.migrationPlanOverride,
        header: 'Migration Plan Override',
        hidden: true,
        id: 'migrationPlanOverride',
    },
    createdAt: {
        cell: (item: Server) => item.createdAt,
        header: 'Created At',
        hidden: true,
        id: 'createdAt',
    },
    updatedAt: {
        cell: (item: Server) => item.updatedAt,
        header: 'Updated At',
        hidden: true,
        id: 'updatedAt',
    },
};
